import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import LogRocket from 'logrocket';
import 'normalize.css/normalize.css';
import { ThemeProvider } from 'styled-components';

import { store } from 'redux/store';

import { AuthIsNotSignedIn, AuthIsSignedIn, AuthProvider } from 'contexts/AuthContext';
import { BucketProvider } from 'contexts/BucketContext';

import { GlobalStyle } from 'themes/globalStyles';
import { theme } from 'themes/theme';

import { routes } from 'data/routes';

import { DefaultLayout } from 'layouts/DefaultLayout';

import { CataloguePage } from 'pages/Catalogue';
// Customer Mapper feature disabled for now
// import { CustomersPage } from 'pages/Customers';
import { LoginPage } from 'pages/Login';
import { UsersPage } from 'pages/Users';

import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';

import { Forbidden } from './Forbidden';

LogRocket.init(process.env.REACT_APP_LOGROCKET_ID!);

function MainRoute(): React.ReactElement {
  return (
    <DefaultLayout>
      <ErrorBoundary>
        <Routes>
          <Route path="/" element={<Navigate to={`${routes.users}/`} />} />

          {/* Customer Mapper feature disabled for now */}
          {/* <Route path={`${routes.customers}/*`} element={<CustomersPage />} /> */}

          <Route path={`${routes.catalogue}/*`} element={<CataloguePage />} />

          <Route path={`${routes.users}/*`} element={<UsersPage />} />

          <Route path="*" element={<Navigate to="/" replace />} />

          <Route path={`${routes.forbidden}`} element={<Forbidden />} />
        </Routes>
      </ErrorBoundary>
    </DefaultLayout>
  );
}

function SignInRoute(): React.ReactElement {
  return (
    <Routes>
      <Route path="/" element={<Navigate to={routes.login} />} />

      <Route path={`${routes.login}/*`} element={<LoginPage />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export function App() {
  useEffect(() => {
    window.process = {
      ...window.process,
    };
  }, []);

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <Toaster />

        <Router>
          <AuthProvider>
            <BucketProvider>
              <AuthIsNotSignedIn>
                <SignInRoute />
              </AuthIsNotSignedIn>

              <AuthIsSignedIn>
                <MainRoute />
              </AuthIsSignedIn>
            </BucketProvider>
          </AuthProvider>
        </Router>

        <div id="portalContext" />
      </ThemeProvider>
    </Provider>
  );
}
